import { errorClose, errorShow } from "./constants"

export function closeError() {
  return errorClose()
}

export function showError(error) {
  return errorShow(error)
}
